import { gql } from '@apollo/client';

const PARAGRAPH_FIELDS = `
  id
  title
  subtitle
  hskLevel
  timeMinutes
  charCount
  sentences {
    zh
    py
    en
    hint
    audio
  }
  referenceTranslation
  createdAt
  updatedAt
`;

export const CREATE_PARAGRAPH = gql`
  mutation CreateParagraph($input: CreateParagraphInput!) {
    createParagraph(input: $input) {
      ${PARAGRAPH_FIELDS}
    }
  }
`;

export const UPDATE_PARAGRAPH = gql`
  mutation UpdateParagraph($id: ID!, $input: UpdateParagraphInput!) {
    updateParagraph(id: $id, input: $input) {
      ${PARAGRAPH_FIELDS}
    }
  }
`;

export const DELETE_PARAGRAPH = gql`
  mutation DeleteParagraph($id: ID!) {
    deleteParagraph(id: $id)
  }
`;

export const SEED_SAMPLE_PARAGRAPHS = gql`
  mutation SeedSampleParagraphs {
    seedSampleParagraphs {
      ${PARAGRAPH_FIELDS}
    }
  }
`;

export const SUBMIT_TRANSLATION = gql`
  mutation SubmitTranslation($paragraphId: ID!, $translation: String!) {
    submitTranslation(paragraphId: $paragraphId, translation: $translation) {
      score
      scoreLabel
      notes {
        type
        text
      }
      referenceTranslation
    }
  }
`;
